import { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { rtdb } from '@/lib/firebase';

export interface StaffPresence {
  staffId: string;
  state: 'online' | 'away';
  lastActive: number;
  displayName: string;
  currentPage?: string;
}

/**
 * Hook admin/staff pour voir qui est en ligne en temps réel.
 * Retourne la liste triée : online d'abord, puis away, puis par activité récente.
 */
export function useOnlineStaff() {
  const [presence, setPresence] = useState<StaffPresence[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const presenceRef = ref(rtdb, 'presence');
    const unsub = onValue(
      presenceRef,
      (snap) => {
        const val = snap.val() || {};
        const list: StaffPresence[] = Object.entries(val).map(([staffId, data]: [string, any]) => ({
          staffId,
          state: data.state,
          lastActive: data.lastActive,
          displayName: data.displayName || staffId,
          currentPage: data.currentPage,
        }));
        list.sort((a, b) => {
          if (a.state !== b.state) return a.state === 'online' ? -1 : 1;
          return b.lastActive - a.lastActive;
        });
        setPresence(list);
        setLoading(false);
      },
      (err) => {
        console.error('[useOnlineStaff] listener error:', err);
        setLoading(false);
      }
    );
    return () => unsub();
  }, []);

  return { presence, loading, onlineCount: presence.filter((p) => p.state === 'online').length };
}